import type { IEquipment } from '@/types/hvl/Equipment'
import type { IEquipmentFilters } from '@/types/hvl/filters'
import type { IEquipmentUpsertForm } from '@/types/hvl/forms'
import type { IPage } from '@/types/shared/pagination'
import axios from 'axios'

export async function getEquipment(filters: IEquipmentFilters): Promise<IPage<IEquipment>> {
  const res = await axios.get(import.meta.env.VITE_APP_HVL_EQUIPMENT_ENDPOINT, {
    params: filters,
  })
  return res.data
}

export async function createEquipment(form: IEquipmentUpsertForm): Promise<any> {
  const res = await axios.post(import.meta.env.VITE_APP_HVL_EQUIPMENT_ENDPOINT, form)
  return res.data
}

export async function updateEquipment(id: number, form: IEquipmentUpsertForm): Promise<any> {
  const res = await axios.put(`${import.meta.env.VITE_APP_HVL_EQUIPMENT_ENDPOINT}/${id}`, form)
  return res.data
}

export async function deleteEquipment(id: number): Promise<any> {
  const res = await axios.delete(`${import.meta.env.VITE_APP_HVL_EQUIPMENT_ENDPOINT}/${id}`)
  return res.data
}
